import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { IdentityInfo } from '../components/profil/IdentityInfo';
import { ContactInfo } from '../components/profil/ContactInfo';
import { CardShortcuts } from '../components/profil/CardShortcuts';
import { AccountNav, type PanelId } from '../components/profil/AccountNav';
import { AtnaHelp } from '../components/profil/AtnaHelp';
import { AccountManagement } from '../components/profil/AccountManagement';
import { AccountPanel } from '../components/profil/AccountPanel';
import { EditCardDialog } from '../components/carte/EditCardDialog';
import { useDebug } from '../contexts/DebugContext';
import type { FamilyMember } from '../data/carte';
export function MonProfil() {
  const [panel, setPanel] = useState<PanelId | null>(null);
  const [editing, setEditing] = useState<FamilyMember | null>(null);
  const {
    hasCard
  } = useDebug();
  return <main id="profil" className="bg-white" data-id="element-3287" data-mp="1cf6dcjrnvzzu">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-3288" data-mp="1cg7pysobsujo">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-3289" data-mp="1hesp0orud86j">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-3290" data-mp="1mbsv2zooyaxn">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3291" data-mp="1r4visr6seq5x" />
          <span aria-current="page" data-id="element-3292" data-mp="1v44brtu06k0f">Mon profil</span>
        </nav>

        <header className="mt-4" data-id="element-3293" data-mp="203z0bqqb2xib">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-3294" data-mp="2037cx36v4634">Mon profil</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-3295" data-mp="254mz4yks0in3">
            Gérez vos informations personnelles, vos préférences et vos options de confidentialité.
          </p>
        </header>

        <div className="mt-8 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,360px)] lg:gap-10" data-id="element-3296" data-mp="aqm1gh0yq1ol">
          <div data-id="element-3297" data-mp="fp6unwhsrl3j">
            <IdentityInfo hasCard={hasCard} onEditCard={setEditing} data-id="element-3298" data-mp="fonlp5a4k71n" />
            <ContactInfo data-id="element-3299" data-mp="7or1ndu9f6ex" />
            <CardShortcuts data-id="element-3300" data-mp="7ny2oz1jll7c" />
          </div>

          <div data-id="element-3301" data-mp="2p4p76m99u76">
            <AccountNav onOpen={setPanel} data-id="element-3302" data-mp="2pedmprnjtar" />
            <AtnaHelp data-id="element-3303" data-mp="2qplb0o7xl75" />
          </div>
        </div>

        <AccountManagement data-id="element-3304" data-mp="hm5gxa4g5p5n" />
      </div>

      <AccountPanel panel={panel} onClose={() => setPanel(null)} data-id="element-3305" data-mp="hn6rzelgqbnd" />

      <AnimatePresence data-id="element-3306" data-mp="clrc00y56vbu">
        {editing && <EditCardDialog member={editing} onClose={() => setEditing(null)} data-id="element-3307" data-mp="covlndudmj9w" />}
      </AnimatePresence>
    </main>;
}